/** Marge CashLive sur le tarif Sendcloud brut (identique à l’admin CarrierFinder) */
export const SENDCLOUD_MARKUP_RATE = 0.2;

export function applySendcloudMarkup(value: number | string | null | undefined): number {
  const numericValue = Number(value) || 0;
  const markedValue = numericValue * (1 + SENDCLOUD_MARKUP_RATE);
  return Math.round(markedValue * 100) / 100;
}

/** Sendcloud renvoie souvent `iso_2` au lieu de `code` sur les pays */
export function sendcloudCountryCode(c: { code?: string; iso_2?: string }): string {
  return String(c?.code || c?.iso_2 || '').trim().toUpperCase();
}

export function formatSendcloudWeightKg(n: number): string {
  return Number(n).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 3 });
}
